import { formatKoreanWon } from '../model/configuration';

export function formatOptionPrice(price: number): string {
  if (price === 0) {
    return '기본 포함';
  }
  return `+${formatKoreanWon(price)}`;
}
